<template>
  <div class="home-page">
    <!-- 精选产品区 -->
    <section class="section product-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('m.featuredProducts') }}</h2>
          <p class="section-subtitle">Selected Products</p>
          <div class="section-line"></div>
        </div>
        <div class="product-grid" v-if="productlist.length">
          <div
            class="product-card subcat-card"
            v-for="(item, index) in productlist.slice(0, 3)"
            :key="index"
            @click="toProductSub(item)"
          >
            <div class="product-img-box">
              <img :src="fixUrl(item.img)" :alt="item.name" class="product-img">
              <div class="product-hover-mask">
                <span class="product-hover-text">{{ $t('m.viewDetails') }}</span>
              </div>
            </div>
            <div class="product-info">
              <h3 class="product-name">{{ item.name }}</h3>
              <div class="product-more">
                <span>{{ $t('m.viewDetails') }}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="product-more-btn" v-if="productlist.length" @click="toProductList">
          {{ $t('m.viewMoreProducts') }} <i class="el-icon-arrow-right"></i>
        </div>
        <div class="empty-tip" v-else>{{ $t('m.noProduct') }}</div>
      </div>
    </section>

    <!-- 新闻动态区 -->
    <section class="section news-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('m.news') }}</h2>
          <p class="section-subtitle">News & Updates</p>
          <div class="section-line"></div>
        </div>
        <div class="news-content" v-if="newsList.length">
          <!-- 左侧重点新闻 -->
          <div class="news-featured" @click="toNewsDetail(newsList[0])">
            <div class="news-featured-img-box">
              <img :src="fixUrl(newsList[0].url_image)" :alt="newsList[0].title_name" class="news-featured-img">
              <div class="news-featured-mask"></div>
              <div class="news-featured-info">
                <span class="news-featured-tag">{{ $t('m.featured') }}</span>
                <h3 class="news-featured-title">{{ newsList[0].title_name }}</h3>
                <div class="news-featured-meta">
                  <span v-if="newsList[0].create_time">{{ newsList[0].create_time }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 右侧新闻列表 -->
          <div class="news-list">
            <div
              class="news-item"
              v-for="(item, index) in newsList.slice(1, 5)"
              :key="index"
              @click="toNewsDetail(item)"
            >
              <div class="news-item-index">{{ String(index + 1).padStart(2, '0') }}</div>
              <div class="news-item-content">
                <h4 class="news-item-title text-ellipsis">{{ item.title_name }}</h4>
                <div class="news-item-desc text-ellipsis-2">{{ summary(item.textcontent) }}</div>
                <div class="news-item-meta">
                  <span v-if="item.create_time"><i class="el-icon-time"></i> {{ item.create_time }}</span>
                  <span class="news-item-more">{{ $t('m.readMore') }} <i class="el-icon-arrow-right"></i></span>
                </div>
              </div>
            </div>
            <div class="news-more-btn" @click="toNewsList">
              {{ $t('m.viewMoreNews') }} <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="empty-tip" v-else>{{ $t('m.noMore') }}</div>
      </div>
    </section>
  </div>
</template>

<script>
import url from "../request/base";
import { fixUrl as fixImgUrl, toPlainSummary } from "../utils/site";
export default {
  data() {
    return {
      imgurl: url.baseUrlimg,
      productlist: [],
      newsList: [],
      // 新闻动态顶级栏目 id：loadNews 动态解析后回填（兜底 3）。
      // 进详情 / 查看全部新闻都带它，避免用 0 当占位值——后端 categoryDetails
      // 收到 id=0 会直接返回空，列表页就成了空白页
      newsPid: 3
    }
  },
  created() {
    this.loadNews()
    this.product()
  },
  methods: {
    // 拼接图片地址：后端若已返回完整 URL 则不再拼前缀
    fixUrl(path) {
      return fixImgUrl(this.imgurl, path)
    },
    // 列表简介取纯文本摘要，避免富文本被 CSS 截断后撑破布局
    summary(html) {
      return toPlainSummary(html, 80)
    },
    // 首页新闻：取「新闻动态」栏目的最新文章（自动找顶级 list 栏目，找不到兜底 pid=3）
    // 不再用 getHomeC 的 datanology/databroad——那两路数据是硬编码栏目/分类导航，不是新闻文章
    async loadNews() {
      let pid = 3
      try {
        const res = await this.$api.home.getnavList({ lang: 'zn' })
        let cat = res && res.data && res.data.category
        if (!Array.isArray(cat)) {
          cat = Array.isArray(res.data) ? res.data : Object.values(res.data || {})
        }
        const tops = cat.filter(c => Number(c.pid) === 0 && c.type === 'list')
        const newsTop = tops.find(c => (c.name || '').indexOf('新闻') > -1) || tops[0]
        if (newsTop) pid = newsTop.id
      } catch (e) { /* 用兜底 pid */ }
      // 记下真实栏目 id，供跳转使用（详情页返回列表要靠它查到数据）
      this.newsPid = pid
      this.$api.home.getcList({ id: pid, page: 1, limit: 5 }).then(r => {
        if (r && r.data && r.data.list && r.data.list.length) {
          this.newsList = r.data.list.slice(0, 5)
        }
      }).catch(() => {})
    },
    // 首页产品：与新闻一致用 categoryDetails（会自动带出子分类文章）
    // 不再用 productIndex——那接口只查顶级直挂文章，文章一旦归到子分类下就返回空
    // 首页产品：展示产品中心(11)的子分类，不展示文章
    product() {
      this.$api.home.getnavList({ lang: 'zn' }).then(res => {
        let cat = res && res.data && res.data.category
        if (!Array.isArray(cat)) return
        const subs = cat
          .filter(i => Number(i.pid) === 11 && Number(i.is_menu) === 1)
          .map(i => ({ id: i.id, name: i.name, img: i.url_image }))
          .sort((a, b) => a.id - b.id)
        this.productlist = subs
      }).catch(() => {})
    },
    // 跳转新闻详情：带上真实新闻栏目 id，详情页据此显示面包屑，
    // 并在"返回列表"时把可查到的分类 id 带回列表页
    toNewsDetail(item) {
      this.$router.push({
        path: '/latestbroadcast/latestdetail',
        query: {
          id: item.id,
          name: item.title_name,
          pname: this.$t('m.news'),
          pid: this.newsPid
        }
      })
    },
    // 跳转新闻列表：同样带真实栏目 id，不依赖 Latestbroadcast 兜底
    toNewsList() {
      this.$router.push({
        path: '/latestbroadcast',
        query: { pname: this.$t('m.news'), pid: this.newsPid }
      })
    },
    // 跳转产品中心列表页
    toProductList() {
      this.$router.push({
        path: '/salesdepartmentukbranch',
        query: { pname: this.$t('m.productCenter'), pid: 11 }
      })
    },
    // 点子分类 → 进该子分类文章列表页
    toProductSub(item) {
      this.$router.push({
        path: '/salesdepartmentukbranch',
        query: { pname: item.name, pid: item.id }
      })
    }
  }
}
</script>

<style scoped>
.home-page {
  min-width: 1200px;
  background-color: var(--color-bg-white);
}

/* ========== 通用区块 ========== */
.section {
  padding: 70px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-title {
  font-size: 32px;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0;
  letter-spacing: 2px;
}

.section-subtitle {
  font-size: var(--font-size-sm);
  color: var(--color-text-placeholder);
  margin: 8px 0 0 0;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.section-line {
  width: 50px;
  height: 3px;
  background-color: var(--color-primary);
  margin: 20px auto 0;
  border-radius: 2px;
}

.empty-tip {
  text-align: center;
  padding: 60px 0;
  color: var(--color-text-placeholder);
  font-size: var(--font-size-md);
}

/* ========== 产品区 ========== */
.product-section {
  background-color: var(--color-bg-white);
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

/* ========== 子分类卡片（产品中心首页，带分类封面图） ==========
   图片区复用 .product-img-box / .product-img / .product-hover-mask，
   这里只解除原先"无图纯文字"版本留下的居中约束 */
.product-card.subcat-card {
  display: block;
  padding: 0;
  min-height: 0;
}
.product-card.subcat-card .product-img-box {
  height: 200px;
}
.product-card.subcat-card .product-info {
  text-align: center;
}
.product-card.subcat-card .product-name {
  font-size: 22px;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0 0 12px;
  letter-spacing: 1px;
}
.product-card.subcat-card .product-more {
  color: var(--color-primary);
  font-size: var(--font-size-sm);
  transition: transform var(--transition-normal);
}
.product-card.subcat-card:hover .product-more {
  transform: translateX(4px);
}

.product-card {
  background-color: var(--color-bg-white);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  transition: all var(--transition-normal);
  border: 1px solid var(--color-border-light);
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-lg);
  border-color: var(--color-primary-light);
}

.product-img-box {
  position: relative;
  width: 100%;
  height: 240px;
  overflow: hidden;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--transition-slow);
}

.product-card:hover .product-img {
  transform: scale(1.08);
}

.product-hover-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(74, 54, 35, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity var(--transition-normal);
}

.product-card:hover .product-hover-mask {
  opacity: 1;
}

.product-hover-text {
  color: var(--color-text-inverse);
  font-size: var(--font-size-md);
  border: 2px solid var(--color-text-inverse);
  padding: 10px 30px;
  border-radius: var(--radius-full);
  letter-spacing: 2px;
}

.product-info {
  padding: 24px;
}

.product-name {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  margin: 0 0 12px 0;
  transition: color var(--transition-fast);
}

.product-card:hover .product-name {
  color: var(--color-primary);
}

.product-desc {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
  height: 44px;
  margin-bottom: 16px;
}

.product-desc :deep(img) {
  display: none;
}

.product-more {
  display: flex;
  align-items: center;
  font-size: var(--font-size-sm);
  color: var(--color-primary);
  font-weight: var(--font-weight-medium);
}

.product-more i {
  margin-left: 6px;
  transition: transform var(--transition-fast);
}

.product-card:hover .product-more i {
  transform: translateX(4px);
}

/* ========== 新闻区 ========== */
.news-section {
  background-color: var(--color-bg-light);
}

.news-content {
  display: flex;
  gap: 30px;
}

/* 左侧重点新闻 */
.news-featured {
  flex: 1;
  cursor: pointer;
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: transform var(--transition-normal);
}

.news-featured:hover {
  transform: translateY(-4px);
}

.news-featured-img-box {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 420px;
}

.news-featured-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-featured-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.1) 60%, transparent 100%);
}

.news-featured-info {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 30px;
  color: var(--color-text-inverse);
}

.news-featured-tag {
  display: inline-block;
  background-color: var(--color-accent);
  color: var(--color-text-inverse);
  font-size: var(--font-size-xs);
  padding: 4px 12px;
  border-radius: var(--radius-full);
  margin-bottom: 12px;
  letter-spacing: 1px;
}

.news-featured-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  margin: 0 0 10px 0;
  line-height: var(--line-height-tight);
}

.news-featured-meta {
  font-size: var(--font-size-sm);
  opacity: 0.7;
}

/* 右侧新闻列表 */
.news-list {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.news-item {
  display: flex;
  gap: 20px;
  padding: 20px;
  background-color: var(--color-bg-white);
  border-radius: var(--radius-md);
  margin-bottom: 16px;
  cursor: pointer;
  transition: all var(--transition-fast);
  border: 1px solid transparent;
}

.news-item:hover {
  border-color: var(--color-primary-light);
  box-shadow: var(--shadow-sm);
  transform: translateX(4px);
}

.news-item-index {
  font-size: 28px;
  font-weight: var(--font-weight-bold);
  color: var(--color-primary-bg);
  line-height: 1;
  flex-shrink: 0;
  width: 40px;
  transition: color var(--transition-fast);
}

.news-item:hover .news-item-index {
  color: var(--color-primary);
}

.news-item-content {
  flex: 1;
  min-width: 0;
}

.news-item-title {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  margin: 0 0 8px 0;
  transition: color var(--transition-fast);
}

.news-item:hover .news-item-title {
  color: var(--color-primary);
}

.news-item-desc {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
  height: 40px;
  margin-bottom: 10px;
}

.news-item-desc :deep(img) {
  display: none;
}

.news-item-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: var(--font-size-xs);
  color: var(--color-text-placeholder);
}

.news-item-more {
  color: var(--color-primary);
  cursor: pointer;
  transition: transform var(--transition-fast);
}

.news-item:hover .news-item-more {
  transform: translateX(4px);
}

.news-more-btn {
  text-align: center;
  padding: 14px;
  background-color: var(--color-accent);
  color: var(--color-text-inverse);
  border-radius: var(--radius-md);
  cursor: pointer;
  font-size: var(--font-size-sm);
  letter-spacing: 2px;
  transition: all var(--transition-fast);
  margin-top: auto;
}

.news-more-btn:hover {
  background-color: var(--color-accent-dark);
  box-shadow: var(--shadow-primary);
}

/* 产品区"查看更多产品"按钮（与新闻按钮同款） */
.product-more-btn {
  text-align: center;
  padding: 14px;
  background-color: var(--color-accent);
  color: var(--color-text-inverse);
  border-radius: var(--radius-md);
  cursor: pointer;
  font-size: var(--font-size-sm);
  letter-spacing: 2px;
  transition: all var(--transition-fast);
  margin-top: 40px;
}

.product-more-btn:hover {
  background-color: var(--color-accent-dark);
  box-shadow: var(--shadow-primary);
}
</style>
